<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-type="flex" vs-w="6">
        <div
          v-if="kuverSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Kuver Ayarı</span>
          </div>
          <form data-vv-scope="form-pos-ip-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <vs-col vs-w="6">
                <span class="weight-600">Durum :</span>
                <vs-switch class="ml-2" v-model="kuverSettings.isEnable">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Kuver Ücreti (TL) </span>
              <vs-input
                v-validate="{ required: true, min_value: 0 }"
                name="Kuver Ücreti"
                v-model="kuverSettings.unitPrice"
                type="number"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.Kuver Ücreti")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-pos-ip-settings.API URL')"
                color="success"
                @click="submitKuverSettings"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
import { setKuverSetting, getKuverSetting } from "@/api/Kuver";
export default {
  name: "KuverSettings",
  data() {
    return {
      kuverSettings: {
        isEnable: false,
        unitPrice: 0
      },
    };
  },
  methods: {
    submitKuverSettings: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-pos-ip-settings");
      if(!checker){
        return;
      }
      setKuverSetting(this.kuverSettings)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Kuver Ayarları Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Kuver Ayarları Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
    },
    getKuverSetting() {
      getKuverSetting()
        .then((res) => {
          if (res && res.status === 200) {
            this.kuverSettings = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kuver Ayarları Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
  },
  created: async function () {
    await this.getKuverSetting();
  },
};
</script>
<style></style>
